module.exports = __webpack_public_path__ + "img/wisa.53ec4829.png";